import styled from "styled-components";
import { theme } from "../../styles/theme";

export const ViewToggleRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 16px;
`;

export const DocsCardsGrid = styled.div`
  width: 100%;

  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 14px;
`;

export const DocCard = styled.div`
  width: 100%;
  max-width: 350px;
  padding: 16px;

  display: flex;
  flex-direction: column;
  gap: 10px;

  border-radius: 1rem;
  background-color: #f9f9f9;

  cursor: pointer;
  transition: box-shadow .2s ease;

  &:hover {
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  }

  @media only screen and (max-width: 760px) {
    max-width: 100%;
  }
`;

export const DocCardTopRow = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const DocCardOpenButton = styled.button`
  all: unset;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 4px;
  cursor: pointer;
  flex-shrink: 0;
  color: ${theme.colors.gray.Cinza_2};
`;

export const FormContainer = styled.div`
background: #f8f8f9;
height: 1920px;
form {
  background: #f8f8f9;

  margin: auto;
  min-width: 250px;
  display: flex;
  display: block;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 340px;
  height: 60px;
}

margin: 0px;
button {
  padding: 25px;
  margin: 40px 15px 10px 10px;
  width: 340px;
  height: 60px;
}
i {
  margin-left: 15px;
}

#multiselectContainerReact{
  margin: 40px 0 10px 100px;
  ._2OR24XnUXt8OCrysr3G0XI{
    .searchBox{
      margin: 5px 0 30px 10px;
    }      
    span{
      background: #00b43f;
      width: auto;
    }
    background: white;
    width: 400px;
    border-radius: 25px;
  }

}
`;

export const ProdutoresContainer = styled.section`
height: 100%;
padding: 50px 0;

background: ${theme.colors.white.Branco};

.modal-dialog modal-lg modal-dialog-centered{
  display: flex;
  justify-content:center;
}

#botaoformdocs{
  margin-left: 128px;
  margin-top: 24px;
  padding: 10px; 
    button{
      border-radius: 30px;
      border: solid 3px #FFF;
    }   
}

.search-select{
  width: 500px;
  display: flex;
  flex-direction: row;
  margin-top: -110px;

  .add{
    margin-left: 90px;
    margin-top: 8px;
    button{
      border-radius: 30px;
      border: solid 3px #FFF;
    }     

  }

}

.search{
  display: flex;
  flex-direction: row;
  margin-left: 190px;
  margin-top: -80px;
  
  .add{
    margin-left: 90px;
    margin-top: -12px;
    button{
      border-radius: 30px;
      border: solid 3px #FFF;
    }     

  }
}

> div {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .loadmore {
    margin: 30px 0;
    padding: 15px 20px;
  }
  .limpar{
    display: flex;
    justify-content: space-around;
    .botao{
      margin: 40px 30px 40px 1px;
      padding: 15px 50px;
    }
  .filterbuttons {
    width: 100%;
    max-width: 400px;
    .pesquisar {
      margin: 40px 0;
      padding: 20px 80px;
    }
  }
}
  .relatorio {
    display: flex;
    margin-left: 70%;
    padding: 15px 20px;
  }
  .add {
    align-self: flex-end;
    button {
      margin: 15px 0 30px;
      padding: 20px 30px;
    }
  }
}

@media only screen and (max-width: 768px) {
  padding: 24px 0;
  background: #ffffff;
  height: 100%;

.modal-dialog modal-lg modal-dialog-centered{
  display: flex;
  justify-content:center;
}

#botaoformdocs{
  margin-left: 128px;
  margin-top: 24px;
  padding: 10px; 
    button{
      border-radius: 30px;
      border: solid 3px #FFF;
    }   
}

.ght{
    width:100%;
    max-width: 375px;
    margin-left: 0px;
    margin-top: 12px;
    padding: 15px 20px; 
}

.search-select{
  width: 500px;
  display: flex;
  flex-direction: row;
  margin-top: -110px;

  .add{
    width:100%;
    max-width: 375px;
    margin-left: 0px;
    margin-top: 8px;
    button{
      border-radius: 30px;
      border: solid 3px #FFF;
    }     

  }

}


.search{
  display: flex;
  flex-direction: row;
  margin-left: 190px;
  margin-top: -80px;
  
  .add{
    width:100%;
    max-width: 375px;
    margin-left: 0px;
    margin-top: -12px;
    button{
      border-radius: 30px;
      border: solid 3px #FFF;
    }     

  }
}

> div {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .loadmore {
    width:100%;
    max-width: 375px;
    margin-top: -15px;
    padding: 15px 20px;
  }
  .limpar{
    display: flex;
    justify-content: space-around;
    .botao{
      margin: 40px 30px 40px 1px;
      padding: 15px 50px;
    }
  .filterbuttons {
    width: 100%;
    max-width: 400px;
    .pesquisar {
      margin: 40px 0;
      padding: 20px 80px;
    }
  }
}
  .relatorio {
    display: flex;
    margin-left: 70%;
    padding: 15px 20px;
  }
  .add {
    width:100%;
    max-width: 375px;
    margin-left: 0px;
    align-self: center;
    button {
      margin: 15px 0 30px;
      padding: 20px 30px;
    }
  }
}
}
`;

export const ProdutoresAddContainer = styled.div`
padding: 50px 0;
  background: #f8f8f9;
  flex-direction:row;
  
    form {
      margin: auto;
      min-width: 250px;
      max-width: 500px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }

    button {
       
        margin: 30px 0px;
        padding: 15px 80px;
        .add {
       
          justify-content: flex-end;
        }
        i {
          margin-left: 15px;
        }
      }
    
  
  .salvar {
    width: 100%;
    max-width: 400px;
    display: flex;
    justify-content: space-around;
    .salvado {
      margin: 30px 0;
      padding: 20px 49px;
    }
  }

  .crea{
    justify-content: center;
    padding: 30px;
    align-items: flex-end;
    .new{
      padding: 15px 70px;
      margin: 30px;

    }
  }

  #labelcultura{
    margin: 0px 0px 0px 25px;
    font-family: Lato;
    font-size: 14px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #586377;
  }
  
  #multiselectContainerReact{
    margin: 40px 0 10px 100px;
    ._2OR24XnUXt8OCrysr3G0XI{
      .searchBox{
        margin: 5px 0 30px 10px;
      }      
      span{
        background: #00b43f;
        width: auto;
      }
      background: white;
      width: 400px;
      border-radius: 25px;
    }

}


`;

export const ContainerModal = styled.div`
    width: 100%;
    height: auto;
    max-width: 440px;

    gap: 16px;
    margin: auto;
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: ${props => props.marginTop ? props.marginTop : '48px'};
`;

export const ButtonPlans = styled.div`
     width: 100%;
     display: flex;
     margin-top: 1.25rem;
     margin-bottom: 0.938rem;
     flex-direction: row;
     justify-content: center; 
`;

export const FiliaisAddContainer = styled.div`
  form {
    margin: auto;
    min-width: 250px;
    max-width: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    /* Esconde o input de arquivo dentro do formulário */
    input[type='file'] {
      display: none;
    }
    /* Garante esconder pelo id usado no componente */
    #id_input-file {
      display: none;
    }

    .tel{
      width: 100%;
      max-width: 400px;
      margin-top: 0px;
    }

    .input-wrapper label {
      background-color: #fff;
      border-radius: 1px;
      border: dashed 1px #8a92a2;
      color: #8a92a2;
      margin: 10px;
      padding: 12px 20px;
    }
    
    .input-wrapper label:hover {
      background-color: #DCDCDC;
    }

    .input-wrapper label {
      background-color: #fff;
      border-radius: 1px;
      border: 1px dashed #8a92a2;
      color: #8a92a2;
      margin: 10px;
      padding: 12px 20px;
    }
  }
  .salvar {
    width: 100%;
    max-width: 400px;
    margin-top: 20px;
    display: flex;
    justify-content: space-around;
    
    a {
      width: 35%;
    }

    .salvado {
      width: 60%;
      margin: 30px 0;
      padding: 15px 20px;
    }
  }
`;